import { useEffect } from "react";

import { useAppDispatch, useAppSelector } from "./redux_hooks";

import { classroomSelectors, localSelectors } from "store";
import { setHasStageChanged } from "store/reducers/local";

// If the user has never observed a transition to a non-default stage, is not in a breakout,
// and the stage is still empty we assume they're waiting for the class to start.
// This way, accidentally switching from a poll to an empty stage doesn't re-trigger this message.
export const useIsWaitingForClassToStart = () => {
  const dispatch = useAppDispatch();
  const isDefaultStage = useAppSelector(classroomSelectors.selectIsDefaultStage());
  const activeBreakoutSessionId = useAppSelector(
    classroomSelectors.selectActiveBreakoutSessionId(),
  );
  const hasStageChanged = useAppSelector(localSelectors.selectHasStageChanged());

  useEffect(() => {
    if ((!isDefaultStage && !hasStageChanged) || activeBreakoutSessionId) {
      dispatch(setHasStageChanged({ hasStageChanged: true }));
    }
  }, [isDefaultStage, hasStageChanged, activeBreakoutSessionId, dispatch]);

  return isDefaultStage && !hasStageChanged;
};
